module.exports = __webpack_public_path__ + "static/bookmarks-48848cc335d154a02afd5299fd0d943c.png";